import type { PublicAssistant } from "@sdr/schemas/assistants";
import { useMemo } from "react";

const generateTheme = (color: string): Record<string, string> => {
  return {
    "--m-primary-500": color,
  };
};

export interface ThemeProps {
  assistant: PublicAssistant;
  children: React.ReactNode;
}

export const Theme = ({ assistant, children }: ThemeProps) => {
  const theme = useMemo(() => generateTheme(assistant.color), [assistant]);
  return <div style={theme}>{children}</div>;
};
